import { render, staticRenderFns } from "./SettingsSidebar.vue?vue&type=template&id=d1ed6144&"
import script from "./SettingsSidebar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SettingsSidebar.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports